import React, { FunctionComponent, useState } from 'react';
import { styled } from "@mui/material/styles";
import DashboardLayout from '../../../components/layout/layout';

//import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import { Alert, Button, Checkbox, FormControl, FormControlLabel, Grid, MenuItem } from '@mui/material';
import { StyledSelect, StyledTextField } from '../../../components/ui/formInput';
import { useNavigate } from 'react-router-dom';
import { useCreateCPAdminUser } from '../../../hooks/api/user';
import { useGetCities, useGetCountries, useGetStates } from '../../../hooks/api/common';
import AddNewUserIcon from '../../../assets/img/Add New User.png';
import StorageService from '../../../services/storageService';

type ValidateField = {
  invalid: boolean;
  error: string;
};

type ValidateFieldsState = {
  firstName: ValidateField;
  lastName: ValidateField;
  title: ValidateField;
  email: ValidateField;
  phone: ValidateField;
  // fax: ValidateField;
  // addr1: ValidateField;
  // addr2: ValidateField;
  // city: ValidateField;
  // state: ValidateField;
  zip: ValidateField;
  //country: ValidateField;
};

const CheckboxUI = styled(Checkbox)(({ theme }) => ({
  color: 'red',
  '&.Mui-checked': {
    color: '#c3183c',
  },
}));

const AdminUserAdd: FunctionComponent = () => {
  const navigate = useNavigate();
  const { data: countries } = useGetCountries();
  const { mutateAsync: getStates } = useGetStates();
  const { mutateAsync: getCities } = useGetCities();
  const { mutateAsync: createUser } = useCreateCPAdminUser();

  const formValidation: ValidateFieldsState = {
    firstName: { invalid: false, error: '' },
    lastName: { invalid: false, error: '' },
    title: { invalid: false, error: '' },
    email: { invalid: false, error: '' },
    phone: { invalid: false, error: '' },
    // fax: { invalid: false, error: '' },
    // addr1: { invalid: false, error: '' },
    // addr2: { invalid: false, error: '' },
    // city: { invalid: false, error: '' },
    // state: { invalid: false, error: '' },
    zip: { invalid: false, error: '' },
  //  country: { invalid: false, error: '' },
  };
  const [validateFields, setValidateFields] = useState<ValidateFieldsState>(formValidation);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<boolean>();
  const [ stateList, setStateList ] = useState<any[]>([]);
  const [cityList, setCityList] = useState<any[]>([]);
  const [ selectedCountry, setSelectedCountry ] = useState<string>("");
  const [ disabled, setDisabled ] = useState<boolean>(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [fax, setFax] = useState("");
  const [addr1, setAddr1] = useState("");
  const [addr2, setAddr2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [country, setCountry] = useState("");
  const [uploadInventory, setUploadInventory] = useState(false);
  const [enterOrders, setEnterOrders] = useState(false);

  const isValidEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
  };

  const validateForm = () => {
    let valid = true;
    const errors = { ...validateFields };

    if (!firstName?.trim()) {
      errors.firstName = { invalid: true, error: 'First name is required' };
      valid = false;
    } else {
      errors.firstName = { invalid: false, error: '' };
    }

    if (!lastName?.trim()) {
      errors.lastName = { invalid: true, error: 'Last name is required' };
      valid = false;
    } else {
      errors.lastName = { invalid: false, error: '' };
    }

    if (!email?.trim()) {
      errors.email = { invalid: true, error: 'Email is required' };
      valid = false;
    } else if (!isValidEmail(email)) {
      errors.email = { invalid: true, error: 'Please enter a valid email address' };
      valid = false;
    } else {
      errors.email = { invalid: false, error: '' };
    }

    // if (!phone?.trim()) {
    //   errors.phone = { invalid: true, error: 'Phone is required' };
    //   valid = false;
    // } else if (phone?.trim() && !/^\+?[\d\s-]{7,15}$/.test(phone)) {
    //   errors.phone = { invalid: true, error: 'Please enter a valid phone number' };
    //   valid = false;
    // } else {
    //   errors.phone = { invalid: false, error: '' };
    // }

    if (phone?.trim() && !/^\d{10}$/.test(phone.replace(/\D/g, ''))) {
      errors.phone = {
        invalid: true,
        error: "Phone number must be exactly 10 digits",
      };
      valid = false;
    } else {
      errors.phone = { invalid: false, error: "" };
    }

    // if (!addr1?.trim()) {
    //   errors.addr1 = { invalid: true, error: 'Address is required' };
    //   valid = false;
    // } else {
    //   errors.addr1 = { invalid: false, error: '' };
    // }

    // if (!country) {
    //   errors.country = { invalid: true, error: 'Country is required' };
    //   valid = false;
    // } else {
    //   errors.country = { invalid: false, error: '' };
    // }

    // if (!state) {
    //   errors.state = { invalid: true, error: 'State is required' };
    //   valid = false;
    // } else {
    //   errors.state = { invalid: false, error: '' };
    // }

    // if (!city) {
    //   errors.city = { invalid: true, error: 'City is required' };
    //   valid = false;
    // } else {
    //   errors.city = { invalid: false, error: '' };
    // }

    if (zip?.trim() && !/^\d{5}(-\d{4})?$/.test(zip)) {
      errors.zip = { invalid: true, error: 'Please enter a valid ZIP code (e.g. 12345 or 12345-6789)' };
      valid = false;
    } else {
      errors.zip = { invalid: false, error: '' };
    }

    setValidateFields(errors);
    return valid;
  };

  const handleFormAction = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setValidateFields(formValidation);
    if (!validateForm()) {
      return;
    }
    try {
      setDisabled(true);
      const result = await createUser({ 
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        title: title.trim(),
        email: email.toLowerCase().trim(),
        phone: phone.trim(),
        fax: fax.trim(),
        address: addr1.trim(),
        address2: addr2.trim(),
        city: city,
        state: state,
        zip: zip.trim(),
        country: country,
        uploadInventory: uploadInventory,
        enterOrders: enterOrders,
      });
      if (result?.status === 200) {
        setSuccess(true)
        setTimeout(() => {
          // setSuccess(false);
          // setFirstName('');
          // setLastName('');
          // setTitle('');
          // setEmail('');
          // setPhone('');
          // setFax('');
          // setAddr1('');
          // setAddr2('');
          // setCity('');
          // setState('');
          // setZip('');
          // setCountry('');
          // setUploadInventory(false);
          // setEnterOrders(false);
          // setDisabled(false);
          navigate(-1)
        }, 3000);
      } else {
        setDisabled(false);
        setError('An error occurred during login. Please try again.');
        setTimeout(() => {
          setError('');
        }, 3000);
      }
    } catch (err: any) {
      setDisabled(false);
      if (err?.response?.data?.message) {
        setError(err.response.data.message);
      } else if (err?.message) {
        setError(err.message);
      } else {
        setError('An error occurred during login. Please try again.');
      }
    }
  }

  const fetchStates = async (countryCode: string) => {
    const res = await getStates({countryCode: countryCode});
    setStateList(res || []);
  }

  const fetchCities = async (stateCode: string) => {
    const res = await getCities({countryCode: selectedCountry, stateCode: stateCode });
    setCityList(res || []);
  }

  return (
    <>
      <DashboardLayout titleIcon={<img src={AddNewUserIcon} alt="AddNewUserIcon" style={{ width: 35, height: 35 }} />} title={"Add User"} initialBreadcrumbs={"Channel Partners"} levelBreadcrumbs={'CP Admin'} breadcrumbs={'Add User'} activeMenu={'admin'}>
        <form style={{ padding: 20 }}>
          <Grid container spacing={2}>
            <Grid size={4}>
              <StyledTextField
                label="First Name"
                value={firstName}
                onChange={(e: any) => setFirstName(e.target.value)}
                error={validateFields.firstName.invalid}
                helperText={validateFields.firstName.error}
              />
            </Grid>
            <Grid size={4}>
              <StyledTextField
                label="Last Name"
                value={lastName}
                onChange={(e: any) => setLastName(e.target.value)}
                error={validateFields.lastName.invalid}
                helperText={validateFields.lastName.error}
              />
            </Grid>
            <Grid size={4}>
              <StyledTextField
                label="Title"
                value={title}
                onChange={(e: any) => setTitle(e.target.value)}
              />
            </Grid>
            <Grid size={4}>
              <StyledTextField
                label="Email"
                value={email}
                onChange={(e: any) => setEmail(e.target.value)}
                error={validateFields.email.invalid}
                helperText={validateFields.email.error}
              />
            </Grid>
            <Grid size={4}>
              <StyledTextField
                label="Phone"
                value={phone}
                onChange={(e: any) => setPhone(e.target.value)}
                // error={validateFields.phone.invalid}
                // helperText={validateFields.phone.error}
              />
            </Grid>
            <Grid size={4}>
              <StyledTextField
                label="Fax"
                value={fax}
                onChange={(e: any) => setFax(e.target.value)}
              />
            </Grid>
            <Grid size={4}>
              <StyledTextField
                label="Address 1"
                value={addr1}
                onChange={(e: any) => setAddr1(e.target.value)}
                // error={validateFields.addr1.invalid}
                // helperText={validateFields.addr1.error}
              />
            </Grid>
            <Grid size={4}>
              <StyledTextField
                label="Address 2"
                value={addr2}
                onChange={(e: any) => setAddr2(e.target.value)}
              />
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <StyledSelect
                  label="Country"
                  value={country}
                  onChange={(e: any) => {
                    setCountry(e.target.value);
                    setSelectedCountry(e.target.value);
                    fetchStates(e.target.value);
                  }}
                  // error={validateFields.country.invalid}
                  // helperText={validateFields.country.error}
                >
                  {
                    countries?.map((country: any) => (
                      <MenuItem key={country.iso2} value={country.iso2}>
                        {country.name}
                      </MenuItem>
                    ))
                  }
                </StyledSelect>
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <StyledSelect
                  label="State"
                  value={state}
                  onChange={(e: any) => {
                    setState(e.target.value);
                    fetchCities(e.target.value);
                  }}
                  // error={validateFields.state.invalid}
                  // helperText={validateFields.state.error}
                >
                  {
                    stateList?.map((states: any) => (
                      <MenuItem key={states.stateCode} value={states.stateCode}>
                        {states.name}
                      </MenuItem>
                    ))
                  }
                </StyledSelect>
              </FormControl>
            </Grid>
            <Grid size={4}>
              <StyledSelect
                label="City"
                value={city}
                onChange={(e: any) => {
                  setCity(e.target.value);
                }}
                // error={validateFields.city.invalid}
                // helperText={validateFields.city.error}
              >
                {
                  cityList?.map((city: any) => (
                    <MenuItem key={city.id} value={city.id}>
                      {city.name}
                    </MenuItem>
                  ))
                }
              </StyledSelect>
            </Grid>
            <Grid size={4}>
              <StyledTextField
                label="Zip"
                value={zip}
                onChange={(e: any) => setZip(e.target.value)}
                error={validateFields.zip.invalid}
                helperText={validateFields.zip.error}
              />
            </Grid>
            <Grid size={12}>
              {(() => {
                const userInfo = StorageService.getUserInfo();
                const isBarksdaleUser = userInfo?.accessLevel === 'BARKSDALE';
                
                if (isBarksdaleUser) {
                  return (
                    <>
                      <FormControlLabel
                        control={
                          <CheckboxUI
                            checked={uploadInventory}
                            onChange={(e) => setUploadInventory(e.target.checked)}
                          />
                        }
                        label="Upload Inventory"
                      />
                      <FormControlLabel 
                        control={
                          <CheckboxUI
                            checked={enterOrders}
                            onChange={(e) => setEnterOrders(e.target.checked)}
                          />
                        }
                        label="Enter Orders"
                      />
                    </>
                  );
                }
                return null;
              })()}
            </Grid>
            <Grid size={12}>
              {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {error}
                </Alert>
              )}
              {
                success && (
                  <Alert severity="success" sx={{ mt: 2 }}>
                    User added successfully!
                  </Alert>
                )
              }
            </Grid>
            <Grid size={12}>
              <Button disabled={disabled} variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '150px', marginRight: '25px' }} onClick={handleFormAction}>
                ADD USER
              </Button>
              <Button disabled={disabled} variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '150px' }} onClick={() => navigate('/admin')}>
                CANCEL
              </Button>
            </Grid>
          </Grid>
        </form>
      </DashboardLayout>
    </>
  )
};

export default AdminUserAdd;